import { parsePhoneNumberFromString } from "libphonenumber-js/mobile";
const isNextAppointment = (appointmentStart, nextAppointmentStart) => {
  const now = /* @__PURE__ */ new Date();
  const start = new Date(appointmentStart);
  const end = new Date(nextAppointmentStart);
  const isNext = now >= start && now <= end;
  return isNext;
};
const canSendSMS = (phoneNumber) => {
  if (!phoneNumber)
    return false;
  const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
  const phoneType = parsedPhoneNumber == null ? void 0 : parsedPhoneNumber.getType();
  const isMobile = phoneType === "MOBILE";
  return isMobile;
};
const getPatientName = (patient, fallback = "Unknown") => {
  if (!patient)
    return fallback;
  if (patient.firstName && patient.lastName) {
    return `${patient.lastName}, ${patient.firstName}`;
  }
  if (!patient.firstName) {
    return patient.lastName || fallback;
  }
  return patient.firstName || fallback;
};
export {
  canSendSMS,
  getPatientName,
  isNextAppointment
};
